export const slugify = value => value.toString().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

export const buildDataQa = (prefix, value) => `${prefix}-${slugify(value)}`;
